import { render, staticRenderFns } from "./ProductionTraceabilityExams.vue?vue&type=template&id=52209f54&scoped=true"
import script from "./ProductionTraceabilityExams.vue?vue&type=script&lang=js"
export * from "./ProductionTraceabilityExams.vue?vue&type=script&lang=js"
import style0 from "./ProductionTraceabilityExams.vue?vue&type=style&index=0&id=52209f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52209f54",
  null
  
)

export default component.exports